import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  getEngagementList,
  getInitationTypeList,
  getCountryList,
  getServiceTypeList,
  changeInitationType,
  setInitiationValue,
} from '../state/serviceInitActions';
import ChooseInitiationPres from 'src/ui/features/ServiceInit/presentational/ChooseInitiationPres';
import { SI_INITIATION_TYPES } from 'src/constants/constants';

class ChooseInitiationContainer extends React.Component {
  static propTypes = {
    /** Action to retrieve Engagement list for dropdown */
    getEngagementList: PropTypes.func.isRequired,
    /** Action to retrieve Initiation Type list for dropdown */
    getInitationTypeList: PropTypes.func.isRequired,
    /** Action to retrieve Service Type list for dropdown */
    getServiceTypeList: PropTypes.func.isRequired,
    /** Action to retrieve Country list for dropdown */
    getCountryList: PropTypes.func.isRequired,
    /** Current selected engagement type */
    engagement: PropTypes.number,
    /** Current selected initiation type */
    initiationType: PropTypes.number,
    /** Current selected service type */
    serviceType: PropTypes.string,
    /** Is user corp client? */
    isCorpClient: PropTypes.bool.isRequired,
  };

  componentDidMount() {
    const { getEngagementList, getInitationTypeList } = this.props;

    getEngagementList();
    getInitationTypeList();
  }

  // This is a temporary fix to suppress initiaton type for Client 0. Defect 63964"
  componentDidUpdate(prevProps) {
    const { country, serviceType } = prevProps;
    const { initiationTypeList } = this.props;

    if (
      !country &&
      !serviceType &&
      initiationTypeList &&
      initiationTypeList.length > 0 &&
      initiationTypeList !== prevProps.initiationTypeList
    ) {
      let initiationId = null;
      initiationTypeList.map(value => (value.initiationType === 'Individual Initiation' ? (initiationId = value.initiationId) : null));
      this.props.changeInitationType(initiationId);
      this.checkVisibleElements('initiationType', initiationId);
    }
  }

  handleInitiationChange = value => {
    this.props.changeInitationType(value);
    this.checkVisibleElements('initiationType', value);
  };

  handleUpdateValue = (type, value) => {
    this.props.setInitiationValue(type, value);
    this.checkVisibleElements(type, value);
  };

  checkVisibleElements = (type, value) => {
    const { engagement, initiationType, getServiceTypeList, getCountryList } = this.props;

    const opts = {
      engagement,
      initiationType,
      [type]: value,
    };

    if (this.checkServiceTypeVisible(opts)) {
      // note: Vinod says that when CPS integration is complete ideally we will be able to use the engagement value
      // and then apply this to get a better set of data
      getServiceTypeList(2017, []);
      if (opts.serviceType) {
        getCountryList(2017, opts.serviceType);
      }
    }
  };

  checkServiceTypeVisible = ({ engagement, initiationType }) => {
    const isServiceTypeVisible =
      engagement !== '' && initiationType !== -1 && initiationType !== SI_INITIATION_TYPES.BATCH_INITIATION ? true : false;
    return isServiceTypeVisible;
  };

  render() {
    const { getEngagementList, getInitationTypeList, getServiceTypeList, setInitiationValue, ...otherProps } = this.props;
    const isServiceTypeVisible = this.checkServiceTypeVisible(otherProps);

    return (
      <ChooseInitiationPres
        updateValue={this.handleUpdateValue}
        onInitiationChange={this.handleInitiationChange}
        isServiceTypeVisible={isServiceTypeVisible}
        {...otherProps}
      />
    );
  }
}

const mapStateToProps = ({ serviceInit }) => ({
  engagementList: serviceInit.engagementList,
  serviceTypeList: serviceInit.serviceTypeList,
  initiationTypeList: serviceInit.initiationTypeList,
  engagement: serviceInit.addInitiation.engagement,
  initiationType: serviceInit.addInitiation.initiationType,
  serviceType: serviceInit.addInitiation.serviceType,
  country: serviceInit.addInitiation.country,
  countryList: serviceInit.countryList,
});

const mapDispatchToProps = {
  getEngagementList,
  getInitationTypeList,
  getServiceTypeList,
  getCountryList,
  setInitiationValue,
  changeInitationType,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ChooseInitiationContainer);



// WEBPACK FOOTER //
// ./src/ui/features/ServiceInit/containers/ChooseInitiationContainer.js